    import './memories.scss';
    import { useContext, useEffect, useState } from 'react';
    import { MemoriesService } from '../../services/memoriesService';
    import { Chrono, type AccessibilityConfig } from 'react-chrono';
    import './react-chrono.scss'
    import { REACT_CHRONO_THEME } from '../../utils/constants/reactChronoTheme';
    import { AppLightBoxGallery } from '../commons/app-lightbox-gallery/app.lightbox-gallery';
    import i18n from '../../utils/i18n';
    import { LanguageContext } from '../../providers/LanguageProvider';
    import { useTranslation } from 'react-i18next';
    import { DEFAULT_LANGUAGE, LANGUAGES } from '../../utils/constants/languages';
    import { LoaderSpinner } from '../commons/loader-spinner/loader-spinner';
    import { DATE_FORMAT } from '../../utils/dateFormat';
import { SEO } from '../commons/seo/seo';
    export function Memories(){

        const [memoriesList, setMemoriesList] = useState<any[]>([]);
        const [openMemoriesFiles, setOpenMemoriesFiles] = useState(false);
        const [selectedMemory, setSelectedMemory] =  useState<any>(null)
        const lang =useContext(LanguageContext)
        const {t} =useTranslation();
        const [loading, setLoading] = useState(false);

        useEffect(()=>{
   
            const localLanguage = LANGUAGES.find((language)=>language.code==lang.language)?.locale ?? DEFAULT_LANGUAGE?.locale;
            setLoading(true);
            MemoriesService().getAll().then(
            (res)=>{
                const memories = res.data.map(({id,title,description,date,files}:any)=>{

                    const newDate = new Date(date);
                    const localNewDate =  DATE_FORMAT.format(newDate,localLanguage,'M-Y')

                    return{
                        title:localNewDate,
                        cardTitle:title,
                        cardDetailedText:description,
                        media: {
                            type:  "IMAGE",
                            source: { 
                            url: `/api/assets/${files[0].directus_files_id.id}`,

                            },
                            name: {title}
                        },
                        id:id
                    }
            }
            )                
                setMemoriesList(memories);
            }).catch(
                (err:any)=>console.error(err)
            ).finally(()=>{
                setLoading(false);
            });
        },[lang]);


        function openGallery(item:any){
            setOpenMemoriesFiles(true)

            if(!item.id){
                return
            }

            MemoriesService().getFiles(item.id).then(
                (result)=>{
        
                    const filesData = result.data[0].files;
                    if(!filesData) return;

                    const filesArr = filesData.map((file:any)=>{
                        return{
                            src:`/api/assets/${file.directus_files_id.id}`,
                            description:file.directus_file_id?.description,
                            title:item.title
                        }
                    })
                    
                    setSelectedMemory({
                        title:item.title,
                        files:filesArr
                    })

                }
            )

        }

        return(<>
                <div className='page-container'>
                    <SEO
                    title="Souvenirs — Les Toiles de la Juine"
                    description="Découvrez les expositions et événements passés des Toiles de la Juine à travers une sélection de photographies."
                    />
                    {loading ? (
                    <LoaderSpinner visible={true} />
                    ) : (
                    <div>
                        <div className='section-container'>
                            <h1 className='page-title'>{t("memories.label")}</h1>
                        </div>
                        <div className='section-container'>
                            <Chrono 
                                key={i18n.language}
                                theme={REACT_CHRONO_THEME}
                                items={memoriesList}
                                layout={{ cardWidth: 400,cardHeight:600 }}
                                interaction={{ keyboardNavigation: true }}
                                display={{ borderless: true }}
                                animation={{
                                    slideshow: {
                                        enabled: true,
                                        duration: 3000
                                    }
                                }}
                                media={{ height: 400}}
                                i18n={t("chrono",{returnObjects:true}) as any}
                                accessibility={t("chrono.accessibility",{returnObjects:true}) as AccessibilityConfig }
                            >

                                {memoriesList.map((item) => (
                                    <div key={item.id} className="my-card">
                                    <button
                                        onClick={() => {
                                            openGallery(item)
                                        }}
                                    >
                                    {t("memories.open_gallery")}
                                    </button>
                                    </div>
                                ))}
                            </Chrono>
                        </div>
            
                        <div className='section-container'>
                        <div className='section-container'>
                            <AppLightBoxGallery files={selectedMemory?.files} openEl={openMemoriesFiles} setOpenEl={setOpenMemoriesFiles} />
                        </div>
                        </div>
                    </div>)}  
                </div>          
            </>
        )
    }